import { useMemo } from 'react'

export const useIsUserOnBrave = () =>
  useMemo(() => window?.navigator?.brave?.isBrave?.name === 'isBrave', [])
